import {logger, Util} from 'yougile-util'
import {User} from 'yougile-model'
import {Sync} from '@client/sync'
import {SyncEvents} from '@client/sync-events'
import {Backend} from '@common/backend'
import {globals} from '@extensions/globals-base'
import {PageService} from '@extensions/page-service'
import {boardSettingsStore} from '../board-settings/board-settings-store'

export class BoardTabBg {
  private static updateListeners: Map<string, () => void> = new Map()

  private static customSkin = ''
  private static skin = ''

  private static notRenderedSkin = ''
  static loading = 0

  private static triggerRedraw(): void {
    ;[...BoardTabBg.updateListeners.values()].forEach(cb => cb())
  }

  public static init(): void {
    const userId = globals.currentUserId
    const {profileId} = Sync
    if (!userId || !profileId) {
      return
    }
    void BoardTabBg.refresh()
    SyncEvents.addListener(profileId, userId, () => BoardTabBg.refresh())
  }

  public static async refresh(force = false): Promise<void> {
    if (!globals.currentUserId) {
      return
    }

    const board = PageService.getCurrentBoard()
    const boardSkin = board?.data?.tabBgEnabled && board.data?.tabBgSkin
    if (boardSkin) {
      return BoardTabBg.setSkin(boardSkin, force)
    }

    if (BoardTabBg.customSkin) {
      return BoardTabBg.setSkin(BoardTabBg.customSkin, force)
    } else {
      const box = Sync.getProfile()
      const user = box.get(globals.currentUserId) as User
      return BoardTabBg.setSkin(user.skin, force)
    }
  }

  public static getSkin(): string {
    return (
      (BoardTabBg.customSkin ? BoardTabBg.customSkin : BoardTabBg.skin) ||
      BoardTabBg.notRenderedSkin
    )
  }

  public static getBackgroundImage(skin = BoardTabBg.getSkin()): string {
    if (!skin) {
      return ''
    }
    if (skin.startsWith('/user-data/')) {
      const url = Util.isDesktop() ? Backend.toDataUrl(skin) : skin
      return `url("${url}")`
    }

    return `url("/img/backgrounds/bg${skin}.jpg?v=3")`
  }

  // not used, only in scripts
  public static setCustom(skin: string): Promise<void> {
    BoardTabBg.customSkin = skin
    if (!skin) {
      const box = Sync.getProfile()
      const user = box.get(globals.currentUserId) as User
      BoardTabBg.skin = user.skin
    }
    return BoardTabBg.refresh(true)
  }

  public static getSkinUrl(skin: string = BoardTabBg.skin): string {
    if (skin.startsWith('/user-data/')) {
      return Util.isDesktop() ? Backend.toDataUrl(skin) : skin
    } else {
      return `/img/backgrounds/bg${skin}.jpg?v=3`
    }
  }

  /**
   * Refreshes background pattern.
   */
  public static async setSkin(skin: string, force: boolean): Promise<void> {
    if (BoardTabBg.skin === skin) {
      if (force) {
        BoardTabBg.triggerRedraw()
        boardSettingsStore.updateBgTabModified()
      }
      return
    }

    BoardTabBg.notRenderedSkin = skin
    BoardTabBg.skin = skin

    const img = new Image()

    img.src = this.getSkinUrl()

    try {
      await new Promise<void>(resolve => {
        img.onload = () => {
          // case when fast switch tabs
          if (BoardTabBg.skin !== skin) {
            return
          }

          BoardTabBg.triggerRedraw()
          boardSettingsStore.updateBgTabModified()
          resolve()
        }
      })
    } catch (e) {
      logger.error(e)
    }
  }
}
